import { request } from '@bedrock-rdk/utils';
import { HD } from '@bedrock-rdk/constants';
import { getScreenSize } from '../../../modules/tornado/utils/sizes';

export const BASE = 'https://securepubads.g.doubleclick.net/gampad/adx';

export const getImpressionTrackers = ad => {
  let result = [];

  if (!ad || !ad.tracking_url) {
    return result;
  }

  if (ad.tracking_url.view) {
    result.push(ad.tracking_url.view);
  }

  if (Array.isArray(ad.tracking_url.views)) {
    result = result.concat(ad.tracking_url.views);
  }

  return result;
};

export const fetchPauseAd = data =>
  new Promise((resolve, reject) => {
    const { path, targeting } = data || {};
    const { rdid, ...rest } = targeting || {};
    const t = rest
      ? Object.entries(rest)
          .map(([key, value]) => `${key}=${value}`)
          .join('&')
      : undefined;

    const screenSize = getScreenSize();

    const params = Object.entries({
      iu: path,
      sz: '1x1',
      c: Date.now(),
      rdid,
      t,
    })
      .map(([key, value]) => (value ? `${key}=${encodeURIComponent(value)}` : ''))
      .filter(Boolean)
      .join('&');

    request(`${BASE}?${params}`, { responseType: 'json' })
      .then(data => {
        if (typeof data.file_url === 'string') {
          resolve(data);
        } else {
          resolve({
            ...data,
            creatives: [
              {
                image: data.file_url[screenSize === HD ? '1280x720' : '1920x1080'],
                impression: getImpressionTrackers(data),
              },
            ],
          });
        }
      })
      .catch(error => reject(error));
  });
